import { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import AgentsMapComponents from "./mapComponets";
import { Box, Tab, Tabs } from "@mui/material";
import webSocketUrl from "../../../pages/Utils/webSocketUrl";
import { activeDeliveryAgents } from "./data/dummyData";
import MultiSelectAutocomplete from "../../../components/MultiSelectAutocomplete/index";

import CircleInfo from "./info/CircleInfo";

const DeliveryMapView = () => {
  const [data, setData] = useState([]);
  const [agentOptions, setAgentoptions] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [value, setValue] = useState(0);
  const [selectAgent, setSelectAgent] = useState([]);
  const socket = useRef(null);
  const lastRequest = useRef(null);
  const lastResponse = useRef(null);

  useEffect(() => {
    setFilteredData([]);
    socket.current = new WebSocket(`${webSocketUrl}/delivery-tracking/`);

    socket.current.onopen = () => {
      console.log("✅ WebSocket Connected");
    };

    socket.current.onmessage = async (event) => {
      const response = JSON.parse(event.data);

      const receivedData = response.data;
      const receivedAgents = response.agents;

      setData((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(receivedData)) {
          setFilteredData(receivedData);
          return receivedData;
        }
        return prev;
      });
      setAgentoptions((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(receivedAgents)) {
          return receivedAgents;
        }
        return prev;
      });
    };

    socket.current.onerror = (error) => {
      console.error("❌ WebSocket Error:", error);
    };

    socket.current.onclose = () => {
      console.log("❌ WebSocket Disconnected");
    };

    return () => {
      if (socket.current) socket.current.close();
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);

    if (newValue === 0) {
      setFilteredData(data);
    } else if (newValue === 1) {
      const agentsOnly = data?.map((agent) => ({
        ...agent,
        customers: [],
      }));

      setFilteredData(agentsOnly);
    } else if (newValue === 2) {
      const customersOnly = data?.map((agent) => ({
        agentId: agent?.agentId,
        agentName: agent?.agentName,
        customers: agent?.customers,
      }));
      setFilteredData(customersOnly);
    }
  };

  const handleMultipleSelect = (event, newValue) => {
    const ids = newValue?.map((v) => v?.id);
    setSelectAgent(newValue);

    const payload = {
      type: "filter",
      agents: ids,
    };

    // 🧠 Only send if payload is different from lastRequest
    if (socket.current && socket.current.readyState === WebSocket.OPEN) {
      if (JSON.stringify(payload) !== JSON.stringify(lastRequest.current)) {
        lastRequest.current = payload;
        socket.current.send(JSON.stringify(payload));
      } else {
        console.log("⚠️ Skipped duplicate WebSocket send");
      }
    }
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px 10px",
        }}
      >
        <div
          style={{
            display: "flex",

            alignItems: "center",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              marginBottom: 10,
            }}
          >
            Delivery Map View{" "}
          </h2>

          <CircleInfo />
        </div>

        <Box sx={{ width: "35%", bgcolor: "background.paper" }}>
          <Tabs
            value={value}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#2a9941",
                color: "white",
              },
            }}
            centered
          >
            <Tab label="All" />
            <Tab label="Agent" />
            <Tab label="Customer" />
          </Tabs>
        </Box>
        <Box sx={{ width: "30%" }}>
          {value != 2 && (
            <MultiSelectAutocomplete
              id=""
              placeholder="Delivery Persons"
              options={agentOptions}
              value={selectAgent}
              onChange={handleMultipleSelect}
              labelKey="name"
            />
          )}
        </Box>
      </Box>

      <AgentsMapComponents deliveryData={filteredData} />
    </DashboardLayout>
  );
};

export default DeliveryMapView;
